import React from "react";
import { Card, CardContent, makeStyles, Typography, useTheme } from "@material-ui/core";

import { Theme } from "../.themes";
import { arrowSize } from "./InsuranceCoverageSelectBase";
import { Coverage } from "../store/Insurance";
import { BrandsEnum } from "../enums";

export type BaseCoverageCardProps = {
  arrowStyle: any;
  currentCoverage: Coverage;
  recommendedTitle: string | undefined;
  cardRef: React.RefObject<HTMLSpanElement>;
};

export const coverageCardUseStyles = makeStyles((theme: Theme) => ({
  RecommendationCardContent: {
    padding: 24,
  },
  CoverageDescriptionCard: {
    marginBottom: `${arrowSize(theme) - 12}px`,
    backgroundColor: theme.coverageSelect?.descriptionCard?.backgroundColor ?? theme.palette.background.paper,
    border: theme.border + theme.palette.grey[400],
    borderColor: theme.coverageSelect?.descriptionCard?.borderColor ?? theme.palette.grey[400],
    maxWidth: "100%",
    position: "relative",
    overflow: "visible",
    zIndex: 1,
    borderRadius: theme.brand === BrandsEnum.MG ? 12 : 0,
  },
  CoverageDescriptionCardArrow: {
    position: "absolute",
    display: "block",
    width: `${arrowSize(theme)}px`,
    height: `${arrowSize(theme)}px`,
    bottom: `-${arrowSize(theme) / 2 + parseInt(theme.border)}px`,
    left: `calc(50% - ${arrowSize(theme) / 2}px)`,
    transform: "rotate(45deg)",
    backgroundColor: theme.coverageSelect?.descriptionCard?.backgroundColor ?? theme.palette.background.paper,
    border: `${theme.border} ${theme.coverageSelect?.descriptionCard?.borderColor ?? theme.palette.grey[400]}`,
    borderTop: 0,
    borderLeft: 0,
  },
  CardContent: {
    padding: "16px",
  },
  DescriptionText: {
    color: theme.coverageSelect?.descriptionCard?.textColor,
    fontFamily: theme.coverageSelect?.descriptionCard?.fontFamily,
  },
}));

const CoverageCard: React.FC<BaseCoverageCardProps> = (props: BaseCoverageCardProps) => {
  const theme: Theme = useTheme();
  const classes = coverageCardUseStyles(theme);

  const descriptionPopupSize = {
    width: `100%`,
  };

  return (
    <Card className={classes.CoverageDescriptionCard} style={descriptionPopupSize} variant='outlined'>
      {!!props.currentCoverage?.Description && (
        <CardContent className={classes.CardContent}>
          <Typography ref={props.cardRef} className={classes.DescriptionText}>
            {props.currentCoverage?.Description}
          </Typography>
        </CardContent>
      )}
      <span className={classes.CoverageDescriptionCardArrow} style={props.arrowStyle}></span>
    </Card>
  );
};

export default CoverageCard;
